import * as React from "react"

import { mixpanel } from "@iyk/tracking"

import { MixpanelTracking } from "./MixpanelTracking.ts"
import { LoggerTracking, type Tracking } from "./Tracking.ts"

const TrackingContext = React.createContext<{ tracking: Tracking } | null>(null)

export const TrackingProvider = ({ children }: { children: React.ReactNode }) => {
  const tracking = React.useMemo(() => {
    if (typeof window !== "undefined") {
      return new MixpanelTracking(mixpanel)
    }

    // No-op implementation for SSR
    return new LoggerTracking()
  }, [])

  return <TrackingContext.Provider value={{ tracking }}>{children}</TrackingContext.Provider>
}

export function useTracking() {
  const context = React.useContext(TrackingContext)
  if (!context) {
    throw new Error("useTracking must be used within a TrackingProvider")
  }
  return context.tracking
}
